import * as React from 'react';
import '../Home/Buttons.css'
import CustomizedButtonsHardwares from "./CustomButtons/ButtonsCustomHardwares"
import CustomizedButtonsLicencas from './CustomButtons/ButtonsCustomLicencas ';
import CustomizedButtonsExpirando from './CustomButtons/ButtonsCustomLicencasExpirando';
import CustomizedButtonsExpirado from './CustomButtons/ButtonsCustomLicencasExpiradas';
import BtnLicenseWithouHardware from './CustomButtons/ButtonLicWithoutHardware'


function Buttons() {
    return (
        <div className="containerButton">
            <div className="containerLicencasButtons">
                <CustomizedButtonsLicencas />
            </div>
            <div className="containerHardwaresButtons">
                <CustomizedButtonsHardwares />
            </div>
            <div className="containerExpireButtons" >
                <CustomizedButtonsExpirando />
            </div>
            <div className="containerExpiroButtons">
                <CustomizedButtonsExpirado />
            </div>
            <div className="containerLiceWithoutHardwareButtons">
                <BtnLicenseWithouHardware />
                </div>
        </div>
    );
}
export default Buttons